module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "google-map"
  }, [(_vm.searchBar) ? _c('GoogleMapSearchBox', {
    attrs: {
      "embeddedOnMap": true
    },
    on: {
      "placesChanged": _vm.panToPosition
    }
  }) : _vm._e(), _c('div', {
    staticClass: "placeholder",
    attrs: {
      "id": this._uid
    }
  }), _vm._t("default"), (_vm.search_marker) ? _c('google-map-marker', {
    key: _vm.search_marker.title,
    attrs: {
      "position": _vm.search_marker.position,
      "title": _vm.search_marker.title,
      "label": _vm.search_marker.label
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f982252!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/map/GoogleMap.vue
// module id = 2337
// module chunks = 1